
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import BoarderFoodOrderingRequest from "@/components/BoarderFoodOrderingRequest.vue";
import { FETCH_SMART_LINK} from "@/store/action-types";
import SmartLink from "@/model/SmartLink";
import {Action} from "vuex-class";
import {TranslateResult} from "vue-i18n";
import {AUTH_TOKEN} from "@/store/getter-types";

@Component({
    components: {
      BoarderFoodOrderingRequest,
    }
})
export default class PermalinkPage extends Vue {
  @Action(FETCH_SMART_LINK) fetchLink!: ({ (payload: any): Promise<any> })

  private show: boolean = false
  private showInfoMessage: boolean = false
  private smartLink: SmartLink | null = null
  private height: string = 'height: 200px'
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: TranslateResult = ''
  private link:  string = ''

  onResize () {
    this.height = `height: calc(${window.innerHeight}px - 65px`
  }

  onCloseDialog () {
    this.show = false
    this.showInfoMessage = true
  }

  onOkButtonClick () {
    this.showInfoMessage = false
    this.$router.push({name: 'Login'})
  }

  async fetchSmartLink ():Promise<void> {
    const token = this.$store.getters[AUTH_TOKEN]
      const payload: string = this.link
      try {
        const response = await this.fetchLink(payload)
        this.smartLink = response
        if(this.smartLink!.requestKinds[0].name === 'onboarding') {
          this.show = true
        }
      } catch (e) {
        this.$router.push({name: 'Login'})

      }

  }

  mounted() {
    this.link = this.$route.params.link
    this.fetchSmartLink()
  }
}
